const GenreStatus=[
  { value: "1", label: "Monsieur" },
  { value: "2", label: "Madame" },
];


export default GenreStatus;
